import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import VisibilitySensor from "react-visibility-sensor";

function SectionTwo() {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={500}>
      <div id="about" className={`sectionTwo ${isVisible ? "visible" : ""}`}>
        <div className="text">
          <h1 className={`${isVisible ? "visible" : ""}`}>
            {t("lp1_about_title")}
          </h1>
          <div className="list">
            <p 
              className={`${isVisible ? "visible" : ""}`}
              dangerouslySetInnerHTML={{ __html: t("lp1_about_text1") }}
            />
            <p 
              className={`${isVisible ? "visible" : ""}`}
              dangerouslySetInnerHTML={{ __html: t("lp1_about_text2") }}
            />
            {/* <p 
              className={`${isVisible ? "visible" : ""}`}
              dangerouslySetInnerHTML={{ __html: t("lp1_about_text3") }}
            /> */}
            <p 
              className={`${isVisible ? "visible" : ""}`}
              dangerouslySetInnerHTML={{ __html: t("lp1_about_text4") }}
            />
            <p 
              className={`${isVisible ? "visible" : ""}`}
              dangerouslySetInnerHTML={{ __html: t("lp1_about_text5") }}
            />
          </div>
          <a href="#contact" className={`${isVisible ? "visible" : ""}`}>
            <button>{t("lp1_about_button")}</button>
          </a>
        </div>
      </div>
    </VisibilitySensor>
  );
}
export default SectionTwo;